.o-modal
  position: fixed
  inset: 0
  background: rgba(11,29,58,.45)
  display: flex
  align-items: center
  justify-content: center
  z-index: $z-index.modal
  padding: 32px
  // the width asked by each modal is its minimum; larger screens give forms more room
  &__panel
    width: var(--modal-w, 520px)
    max-width: min(100%, 94vw)
    @media (min-width: 1440px)
      width: calc(var(--modal-w, 520px) * 1.18)
    @media (min-width: 1680px)
      width: calc(var(--modal-w, 520px) * 1.32)
    @media (min-width: 1920px)
      width: calc(var(--modal-w, 520px) * 1.45)
    @media (min-width: 2400px)
      width: calc(var(--modal-w, 520px) * 1.6)
    max-height: 100%
    overflow-y: auto
    background: $syncra.surface
    border-radius: $syncra-radius.panel
    border: 1px solid rgba(11,29,58,.06)
    padding: 26px 28px
    box-shadow: unquote($syncra-shadow.modal)
    color: $syncra.ink
  // Same header as the panels: white bar, amber title, a line under it.
  &__head
    display: flex
    justify-content: space-between
    align-items: center
    gap: 16px
    margin: -26px -28px 0
    padding: 16px 28px
    border-bottom: 1px solid $syncra.neutral
    background: linear-gradient(90deg, mix($syncra.primary, $syncra.surface, 6%) 0%, mix($syncra.primary, $syncra.surface, 2%) 40%, $syncra.surface 100%)
    position: sticky
    top: -26px
    z-index: 1
  &__eyebrow
    display: flex
    gap: 6px
    margin-bottom: 9px
  &__title
    margin: 0
    font-family: $base-font-family
    font-size: 19px
    font-weight: $medium
    color: $syncra.ink
    letter-spacing: .005em
  &__meta
    font-size: $syncra-type.body-sm
    color: $syncra.muted
    margin-top: 4px
  // close: a thin outlined circle with an X (after the chosen reference), in the cancel red, filled softly on hover
  &__close
    appearance: none
    position: relative
    width: 34px
    height: 34px
    flex: 0 0 34px
    padding: 0
    border-radius: 50%
    border: 2px solid lighten(#dc3545, 18%)
    background: transparent
    color: lighten(#dc3545, 18%)
    cursor: pointer
    transition: background .2s ease, border-color .2s ease, color .2s ease, transform .25s ease
    &::before, &::after
      content: ''
      position: absolute
      top: 50%
      left: 50%
      width: 15px
      height: 2px
      border-radius: 2px
      background: currentColor
    &::before
      transform: translate(-50%, -50%) rotate(45deg)
    &::after
      transform: translate(-50%, -50%) rotate(-45deg)
    &:hover
      background: rgba(220,53,69,.08)
      border-color: #dc3545
      color: #dc3545
      transform: rotate(90deg)
    &:focus-visible
      outline: 3px solid rgba(220,53,69,.25)
      outline-offset: 2px
    @media (prefers-reduced-motion: reduce)
      transition: none
      &:hover
        transform: none
